// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateKid_form__1GuH_","form__class":"CreateKid_form__class__1JaOP","form__error":"CreateKid_form__error__k62FI"};